import { ChangeEvent, useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { ReactComponent as IconFail } from '../../assets/fail.svg';
import { ReactComponent as IconReminder } from '../../assets/reminder.svg';
import { IOption } from '../../entities';
import styles from './RadioButtons.module.scss';

interface RadioButtonsProps {
  name: string;
  value?: string;
  error?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  options: IOption[];
  reminders?: string[];
}

const RadioButtons: React.FC<RadioButtonsProps> = ({ name, value, error, onChange, title, options, reminders }) => {
  const [isExpanded, setExpanded] = useState(!!error);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  useEffect(() => {
    setExpanded(!!error);
  }, [error]);

  return (
    <div className={styles.container}>
      {title && <span className={styles.title}>{title}</span>}
      <div className={styles.radioButtons}>
        {options.map((option) => (
          <label className={styles.radioButton} key={option.name}>
            <input
              {...getToggleProps()}
              name={name}
              type="radio"
              id={option.name}
              // value={typeof option.value === 'boolean' ? String(option.value) : option.value}
              value={option.value}
              // onChange={(event) => {
              //   onChange(typeof option.value === 'boolean' ? option.value : event.target.value);
              // }}
              onChange={onChange}
              checked={String(option.value) === String(value)}
            />
            <label htmlFor={option.name}>{option.name}</label>
            <span className={styles.button}></span>
          </label>
        ))}
      </div>

      <div {...getCollapseProps()} className={styles.errorLabelContainer}>
        <div className={styles.errorLabel}>
          <IconFail height={20} width={20} />
          <span>{error}</span>
        </div>
      </div>
      {reminders?.map((reminder, index) => (
        <div className={styles.reminder} key={index}>
          <IconReminder />
          <span>{reminder}</span>
        </div>
      ))}
    </div>
  );
};

export default RadioButtons;
